// import Api from 'services/Api'
import { client } from '@/api/ClientContainer'
import { make } from 'vuex-pathify'

// Store states
const state = {
  loading: false,
  loaded: false,
  packages: []
}

// Store custom getters
const customGetters = {
  findById(id) {
    if (typeof state.packages == 'undefined' || state.packages.length == 0) {
      return null
    }

    let filtered = state.packages.filter((item) => item.id == id)
    if (filtered.length != 1) {
      return null
    }
    return filtered[0]
  }
}

// Store custom actions
const customActions = {
  // Niestandardowe akcje tutaj lub w dedykowanej usludze. Chyba lepiej w store,
  //  co najwyżej wyrzucić do dedykowanego pliku gdy bedzie duzo akcji, np. dictionaryActions.js
  //  Dedykowany service aby obsługiwać całość zadan musiałby też mapować gettery, a nie o to raczej chodzi.

  // manually add load items action
  load({ commit }, force) {
    force = !!force
    // Items are being loaded
    if (state.loading) {
      // console.log('aborting - already loading')
      return
    }

    // Store data already loaded
    if (state.loaded && !force) {
      // console.log('aborting - already loaded')
      return
    }

    commit('SET_LOADED', false)
    commit('SET_LOADING', true)

    return client.packages
      .getAllList()
      .then(function (data) {
        // handle success
        let list = []
        if (data['data'] && data['data']['member']) {
          list = data['data']['member']
        }

        // dispatch('blank', list)
        // commit('SET_DATA', JSON.parse(JSON.stringify(list)))
        commit('SET_PACKAGES', list)
      })
      .catch(function (error) {
        // handle error
        // console.log(error)
        // store.set("blank", null)
        return error
      })
      .finally(function () {
        // console.log('finished loading')
        commit('SET_LOADING', false)
        commit('SET_LOADED', true)
      })
  }
}

// ---------------------------------------------
// Create store

// make all mutations and getters
const mutations = make.mutations(state)
// const getters = make.getters(state);
// const actions = make.actions(state)
const getters = {
  ...make.getters(state),
  ...customGetters
}
const actions = {
  // automatically create only `setData()` action
  // ...make.actions('data'),
  // ...make.actions('data@token'),
  ...customActions
}

export default {
  namespaced: true, // add this if in module
  state,
  mutations,
  actions,
  getters
}
